<template>
  <div>
    <app-header />
    <div class="swiper-box" @mousewheel="rollScroll" style="float: left;width: 100%;height: 100vh;">
      <el-carousel sty height="100vh" trigger="click" :loop="false" direction="vertical" :autoplay="false" ref="carousel">
        <el-carousel-item key="1">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/cardiobrain/diyim.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1380px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 448px;height: 148px;font-size: 56px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 74px;float: left;margin-top: 260px;">心脑血管监测预警 <br>救援系统</div>
              <img src="@/assets/images/cardiobrain/diyiimg.png" alt="" style="width: 920px;height:744px;float: right;margin-top: 128px;">
              <div style="width: 192px;height: 72px;font-size: 24px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 36px;float: left;margin-top: 40px;margin-right: 100px;">监测预警健康管理<br>健全完善救援体系</div>
              <div style="width: 200px;height: 50px;background: #FFFFFF;box-shadow: 0px 2px 4px 0px #036BF7;border-radius: 30px;font-size: 16px;font-family: MicrosoftYaHei;color: #0D76FF;line-height: 50px;text-align: center;float: left;margin-top: 100px;cursor: pointer;" @click="cl = true">点击获取报价>></div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="2">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/cardiobrain/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: -60px;top:200px;">CARDIOCEREBRAL MONITORING</div>
              <div style="width: 444px;float: left;margin-left: 0;margin-top: 260px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">吾征AI心脑监测预警系统</div>
                <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;line-height: 26px;margin-top: 30px;">监测 ◆ 筛查 ◆ 预警 ◆ 救援 ◆ 跟踪管理</div>
                <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;margin-top: 30px;">吾征AI心脑监测预警系统，以心脑高发人群的主要发病风险因子为指标，按照年龄、未治疗收缩压、治疗后收缩压、舒张压、糖尿病、吸烟、心血管疾病史、心房纤颤、左心室肥厚、饮食、临床表现等发病因素，通过改进国际先进的弗明汉脑卒中风险算法，构建心脑科学发病风险模型，精准预测未来10年心脑发病、复发风险与概率，及时预判其健康状况，辅助机构或区域为这些用户提供心脑风险（高、中、低）提前预警以及风险干预方案，并通过整合全国全时120救援系统提供24小时的医学紧急救援服务。</div>
              </div>
              <img src="@/assets/images/cardiobrain/diyiimg1.png" alt="" style="width: 697px;height: 481px;float: left;margin-top: 326px;margin-left: 0;">
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="3">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/cardiobrain/diyim2.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:120px;text-align: center;">CORE VALUES</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 52px;text-align: center;">核心价值 风险筛查与实时监测</div>
              </div>
              <img src="@/assets/images/cardiobrain/diyiimg2.png" alt="" style="width: 1202px;height: 502px;float: left;margin-top: 139px;margin-left: 0;">
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="4">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/cardiobrain/zouni.png" alt="" style="width: 230px;height: 230px;position: absolute;z-index: 1;left:46%;top: 37vh;" @click="zouni()" v-if="zoucl">
            <div style="width: 100%;height: 100vh;">
              <video muted loop style="width: 100%;height: 100vh;" id="video">
                <source src="https://ftp.infobigdata.com/vido.mp4" type="video/mp4">
                您的浏览器不支持Video标签。
              </video>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="5">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/cardiobrain/diyiimg3.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:120px;text-align: center;opacity: 0.1;">FOUR SERVICES</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 52px;text-align: center;">四大服务 全方位守护心脑健康</div>
              </div>
              <div style="width: 100%;float: left;margin-top: 100px;">
                <div style="width: 580px;height: 260px;background: #FFFFFF;border-radius: 20px;float: left;margin-left: 0;">
                  <div style="width: 140px;height: 260px;background: #F6FAFF;border-radius: 20px;float: left;">
                    <img src="@/assets/images/cardiobrain/bian1.png" alt="" style="width: 94px;height: 80px;float: left;margin-left: 23px;margin-top: 90px;">
                  </div>
                  <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 26px;width: 440px;float: left;margin-top: 40px;padding-left: 40px;padding-right: 30px;box-sizing: border-box;">筛查</div>
                  <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;width: 440px;float: left;margin-top: 10px;padding-left: 40px;padding-right: 30px;box-sizing: border-box;">系统会为用户做一次详细的初筛，涵盖8个大项，50多个小项，重点筛查心脑血管类的问题，会通过初筛了解用户的家族遗传病史，身体状态、简单指标等几个方面，然后把初筛的数据传输到心脑系统，由系统进行人工智能处理，将用户按照心脑血管疾病的高、中、低风险进行健康定级，生成初筛报告及监测建议。整个流程，用户可自行在APP操作，也可以由机构在后台批量导入完成初筛。</div>
                </div>
                <div style="width: 580px;height: 260px;background: #FFFFFF;border-radius: 20px;float: left;margin-left:40px;">
                  <div style="width: 140px;height: 260px;background: #F6FAFF;border-radius: 20px;float: left;">
                    <img src="@/assets/images/cardiobrain/bian2.png" alt="" style="width: 94px;height: 80px;float: left;margin-left: 23px;margin-top: 90px;">
                  </div>
                  <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 26px;width: 440px;float: left;margin-top: 40px;padding-left: 40px;padding-right: 30px;box-sizing: border-box;">预警</div>
                  <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;width: 440px;float: left;margin-top: 10px;padding-left: 40px;padding-right: 30px;box-sizing: border-box;">系统自动预警：当用户出现危及生命健康的情况时，如心率异常、血氧降低、血压异常、摔倒等情况，系统会自动预警，工作人员致电用户或家人询问详细情况并判断是否需要进一步的检查、治疗或救援。
                    <br>
                    用户SOS触发预警：当有突发情况家人不在身边，手机不在身边时，轻轻按住智能监测手表上的红色按钮3秒以上，系统会立即通知工作人员或家人。
                  </div>
                </div>
                <div style="width: 580px;height: 260px;background: #FFFFFF;border-radius: 20px;float: left;margin-left:0;margin-top: 40px;">
                  <div style="width: 140px;height: 260px;background: #F6FAFF;border-radius: 20px;float: left;">
                    <img src="@/assets/images/cardiobrain/bian3.png" alt="" style="width: 94px;height: 80px;float: left;margin-left: 23px;margin-top: 90px;">
                  </div>
                  <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 26px;width: 440px;float: left;margin-top: 40px;padding-left: 40px;padding-right: 30px;box-sizing: border-box;">监测</div>
                  <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;width: 440px;float: left;margin-top: 10px;padding-left: 40px;padding-right: 30px;box-sizing: border-box;">系统根据用户的初筛定级形成针对个人的个性化预警方案。可在后台可针对高、中、低危用户灵活设置不同的检测频率，例如：低危人群每4小时进行一次监测；中危人群每2小时进行一次监测；高危人群每15分钟进行一次监测。并自动将监测数据传输到计算中心进行人工智能处理。
                  </div>
                </div>
                <div style="width: 580px;height: 260px;background: #FFFFFF;border-radius: 20px;float: left;margin-left:40px;margin-top: 40px;">
                  <div style="width: 140px;height: 260px;background: #F6FAFF;border-radius: 20px;float: left;">
                    <img src="@/assets/images/cardiobrain/bian4.png" alt="" style="width: 94px;height: 80px;float: left;margin-left: 23px;margin-top: 90px;">
                  </div>
                  <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 26px;width: 440px;float: left;margin-top: 40px;padding-left: 40px;padding-right: 30px;box-sizing: border-box;">救援</div>
                  <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;width: 440px;float: left;margin-top: 10px;padding-left: 40px;padding-right: 30px;box-sizing: border-box;">工作人员确认预警后，会立即采取救援措施。按居民提供的地址或智能监测手表上的GPS定位第一时间为居民提供救援，节省搜索时间。无论居民在国内的任何地方出现紧急情况时，会本着救急就近的原则，第一时间来救护居民的生命安全！
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="6">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:120px;text-align: center;">TECHNICAL SUPERIORITY</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">技术优势</div>
                <div style="width: 100%;float: left;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;margin-top: 100px;text-align: center;">心脑监测预警手表+AI认知算法+APP+数据管理平台+数字大屏<br>
                  构建吾征AI心脑血管疾病风险评估与筛查系统</div>
              </div>
              <div style="width: 100%;float: left;margin-top: 80px;">
                <div style="width: 285px;height: 400px;background: linear-gradient(360deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;float: left;margin-left: 0;padding: 0 28px;box-sizing: border-box;">
                  <div style="width: 100%;float: left;">
                    <img src="@/assets/images/cardiobrain/she1.png" alt="" style="width: 230px;height: 200px;float: left;">
                  </div>
                  <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 26px;width: 100%;float: left;margin-top: -20px;text-align: center;">心脑监测预警手表</div>
                  <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #fff;line-height: 22px;width: 100%;float: left;margin-top: 16px;">◆ 简单操作；<br>
                    ◆ 心率、血压、血氧、房颤等多量化
                    &nbsp;&nbsp;&nbsp;指标采集；<br>
                    ◆ 4G网络让数据无缝传输；<br>
                    ◆ 综合数据指标分析。</div>
                </div>
                <div style="width: 285px;height: 400px;background: linear-gradient(360deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;float: left;margin-left: 20px;padding: 0 28px;box-sizing: border-box;">
                  <div style="width: 100%;float: left;">
                    <img src="@/assets/images/cardiobrain/she2.png" alt="" style="width: 230px;height: 200px;float: left;">
                  </div>
                  <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 26px;width: 100%;float: left;margin-top: -20px;text-align: center;">AI认知算法</div>
                  <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #fff;line-height: 22px;width: 100%;float: left;margin-top: 16px;">
                    ◆ 7年大数据分析+语义认知算法技术
                    &nbsp;&nbsp;&nbsp;加持，提供高标准认知计算；<br>
                    ◆ 心脑多疾病风险评估与筛查模型；<br>
                    ◆ 心脑精准预警模型。<br>
                  </div>
                </div>
                <div style="width: 285px;height: 400px;background: linear-gradient(360deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;float: left;margin-left: 20px;padding: 0 28px;box-sizing: border-box;">
                  <div style="width: 100%;float: left;">
                    <img src="@/assets/images/cardiobrain/she3.png" alt="" style="width: 230px;height: 200px;float: left;">
                  </div>
                  <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 26px;width: 100%;float: left;margin-top: -20px;text-align: center;">APP远程监护</div>
                  <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #fff;line-height: 22px;width: 100%;float: left;margin-top: 16px;">
                    ◆ 远程心脑健康监护；<br>
                    ◆ 家庭绑定，随时了解家人健康；<br>
                    ◆ 居民的健康风险筛查及预警报告。<br>
                  </div>
                </div>
                <div style="width: 285px;height: 400px;background: linear-gradient(360deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;float: left;margin-left: 20px;padding: 0 28px;box-sizing: border-box;">
                  <div style="width: 100%;float: left;">
                    <img src="@/assets/images/cardiobrain/she4.png" alt="" style="width: 230px;height: 200px;float: left;">
                  </div>
                  <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 26px;width: 100%;float: left;margin-top: -20px;text-align: center;">数据预警平台</div>
                  <div style="font-size: 14px;font-family: MicrosoftYaHei;color: #fff;line-height: 22px;width: 100%;float: left;margin-top: 16px;">
                    为社区、政府职能部门、健康管理机构等提供实时监测、预警、救援及大数据分析服务，包括：<br>
                    ◆ 建立健康档案 ◆ 指标数据监测管理<br>
                    ◆ 心脑疾病早筛 ◆ 认知计算预警分析<br>
                    ◆ 跟踪管理服务 ◆ 全国全时120救援<br>
                    ◆ 异常预警及SOS紧急呼救
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="7">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #F6FAFF;"></div>
            <img src="@/assets/images/cardiobrain/canni.png" alt="" style="width: 580px;height:580px;position: absolute;z-index: 0;left: 35%;top: 324px;">
            <div style="width: 400px;height: 180px;background: #FFFFFF;box-shadow: 0px 4px 20px 0px rgba(13,118,255,0.2);border-radius: 10px;position: absolute;z-index: 1;left: 20%;top: 370px;padding: 30px;box-sizing: border-box;">
              <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">脑卒中风险评估与筛查</div>
              <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;">基于Framingham卒中风险评估模型改良后的研发，计算未来10年内脑卒中发病风险及风险等级。针对不同风险等级提供个性化、专业化的健康管理方案。</div>
            </div>
            <div style="width: 400px;height: 180px;background: #FFFFFF;box-shadow: 0px 4px 20px 0px rgba(13,118,255,0.2);border-radius: 10px;position: absolute;z-index: 1;left: 15%;top: 630px;padding: 30px;box-sizing: border-box;">
              <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">房颤患者卒中风险评估与筛查</div>
              <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;">基于CHADS2模型研发，计算未来1年内房颤患者脑卒中发病风险及风险等级。针对不同风险等级提供个性化、专业化的健康管理方案。</div>
            </div>
            <div style="width: 400px;height: 180px;background: #FFFFFF;box-shadow: 0px 4px 20px 0px rgba(13,118,255,0.2);border-radius: 10px;position: absolute;z-index: 1;left: 39%;top: 740px;padding: 30px;box-sizing: border-box;">
              <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">动脉硬化性心血管疾病风险评估与筛查</div>
              <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;">基于国内最新的China- PAR模型研发，计算未来10年内心血管疾病发病风险及风险等级。针对不同风险等级提供个性化、专业化的健康管理方案。</div>
            </div>
            <div style="width: 400px;height: 180px;background: #FFFFFF;box-shadow: 0px 4px 20px 0px rgba(13,118,255,0.2);border-radius: 10px;position: absolute;z-index: 1;right: 14%;top: 630px;padding: 30px;box-sizing: border-box;">
              <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">冠心病风险评估与筛查</div>
              <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;">基于Framingham心脏病风险评估模型研发计算未来10年内冠心病发病风险及风险等级针对不同风险等级提供个性化、专业化的健康管理方案。</div>
            </div>
            <div style="width: 400px;height: 180px;background: #FFFFFF;box-shadow: 0px 4px 20px 0px rgba(13,118,255,0.2);border-radius: 10px;position: absolute;z-index: 1;right: 20%;top: 370px;padding: 30px;box-sizing: border-box;">
              <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">脑卒中复发风险评估与筛查</div>
              <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;">基于ABCD2模型改良后的研发，计算未来5年内脑卒中复发风险及风险等级。针对不同风险等级提供个性化、专业化的健康管理方案。</div>
            </div>
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 1;left: 0;top: 0;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:120px;text-align: center;">TECHNICAL SUPERIORITY</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">技术优势</div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="8">
          <div style="float: left;width: 100%;position: relative;">
            <!-- <img src="@/assets/images/cardiobrain/diyim4.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;"> -->
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">TECHNICAL SUPERIORITY</div>
              <div style="width: 100%;float: left;margin-top: 140px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 52px;text-align: center;">技术优势</div>
                <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;text-align: center;margin-top: 40px;">通过身体异常信号识别模型提供多维度认知分析及解决方案，应用人工智能深度学习技术，<br>
                  针对不同“个人”智能化制定预警方案，通过身体异常信号识别模型提供多维度认知分析及解决方案</div>
              </div>
              <img src="@/assets/images/cardiobrain/diyiimg4.png" alt="" style="width: 1202px;height: 502px;float: left;margin-top: 80px;margin-left: 0;">
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="9">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #F6FAFF;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">TECHNICAL SUPERIORITY</div>
              <div style="width: 100%;float: left;margin-top: 140px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 52px;text-align: center;">技术优势</div>
                <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #666666;line-height: 22px;text-align: center;margin-top: 40px;">吾征AI心脑 首家对打通了全国全时120救援服务的管理平台</div>
              </div>
              <img src="@/assets/images/cardiobrain/diyiimg5.png" alt="" style="width: 1234px;height: 482px;float: left;margin-top: 80px;margin-left: 0;">
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="10">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">APPLICATION SCENARIOS</div>
              <div style="width: 100%;float: left;margin-top: 140px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 52px;text-align: center;">应用场景</div>
                <div style="width: 100%;float: left;margin-top: 120px;margin-left: 0;">
                  <div class="yin1">
                    <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;">诊所/医院/健康小屋</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;margin-top: 20px;">
                      ◆ 中医诊所连锁<br>
                      ◆ 中医院<br>
                      ◆ 专科医院<br>
                      ◆ 健康小屋<br>
                      ◆ 家庭医生<br>
                    </div>
                  </div>
                  <div class="yin2">
                    <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;">医疗代理商</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;margin-top: 20px;">
                      ◆ 市级、区县、渠道三级代理<br>
                      ◆ 疾病健康管理系统+设备<br>
                    </div>
                  </div>
                  <div class="yin3">
                    <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;">国企/终端客户</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;margin-top: 20px;">
                      针对员工健康和关怀做健康管理服务，增加员工归属感，也通过健康管理，减少和避免过劳事故的发生。
                    </div>
                  </div>
                  <div class="yin5">
                    <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;">康养/连锁机构</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;margin-top: 20px;">
                      ◆ 康养机构<br>
                      ◆ 健康管理机构<br>
                      ◆ 体检机构<br>
                      ◆ 连锁药店<br>
                    </div>
                  </div>
                  <div class="yin4">
                    <div style="width: 100%;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;">司乘人员及高危作业机构</div>
                    <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;margin-top: 20px;">
                      尤其适合公交集团司机、客运货运司机、火车司乘等以及从事野外作业、从事电力、矿山、煤炭、消防安全等健康安全风险较高的机构和企业。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="11">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: linear-gradient(130deg, #387AEE 0%, #66A8FF 100%);"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;opacity: 0.1;">LEARN MORE</div>
              <div style="width: 100%;float: left;margin-top: 140px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 52px;text-align: center;">了解更多</div>
                <div style="width: 100%;float: left;margin-top: 200px;">
                  <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 0;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">更多文章</div>
                      <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #0D76FF;line-height: 22px;margin-top: 30px; text-decoration: underline; "> <a target="_blank" style="color: #0D76FF;" href="https://mp.weixin.qq.com/s/SJdY0WUe-pw5YvoNudVSsQ">◆ 吾征推出心脑血管AI健康管理计划，赋能社区居民美好生活</a> <br><br> <a target="_blank" style="color: #0D76FF;" href="https://mp.weixin.qq.com/s/r1cI473PqSDs_WoHH-xhhQ">◆ 后疫情时代需要监测吗？这些人真需要！</a> <br><br>
                        <a target="_blank" style="color: #0D76FF;" href="https://mp.weixin.qq.com/s/Ak7I7kGKOVbBRwEEDwH0nw">◆ 推动心脑血管疾病防治工程建设，助力心脑辅助诊疗迈上新台阶。</a></div>
                    </div>
                  </div>
                  <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 20px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">资料下载</div>
                      <div style="float: left;width: 200px;height: 60px;background: linear-gradient(318deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;font-size: 14px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 60px;text-align: center;margin-left:70px ;margin-top: 74px;"> <a class="aquchu" href="https://ftp.infobigdata.com/heart_brain_monitoring_system_brochure.pdf" target="_blank">点击下载资料</a> </div>
                    </div>
                  </div>
                  <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 20px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">获取报价</div>
                      <div style="float: left;width: 200px;height: 60px;background: linear-gradient(318deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;font-size: 14px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;text-align: center;margin-left:70px ;margin-top: 74px;padding: 10px 0;box-sizing: border-box;cursor: pointer;" @click="cl = true">点击获取<br>详细方案及报价</div>
                    </div>
                  </div>
                  <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 19px;text-align: center;margin-top: 160px;">© Copyright © 2017-2021 中润普达 - 京ICP备2021002262号-1</div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <app-footer /> -->
    <div style="width: 100%;height: 100vh;position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;z-index: 999;
    background: rgba(0, 0, 0, 0.8);" v-if="cl" @click="cl = false">
      <img src="@/assets/images/cardiobrain/erweima.jpg" alt="" style="width: 10vw;height: 10vw;margin:0 45vw;margin-top:30vh;">
      <div style="width: 100%;text-align: center;font-size: 16px;color: #fff;margin-top: 10px;">扫码添加获取详细方案及报价</div>
    </div>
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'

export default {
  data() {
    return {
      cl: false,
      zoucl: true,
      scrollBox: { time: 300 },

    }
  },
  mounted() {


  },
  methods: {
    zouni() {
      var myVideo = document.getElementById("video");
      if (myVideo.paused) {
        myVideo.play();
        this.zoucl = false;
      } else {
        myVideo.pause();
        this.zoucl = true;

      }

    },
    rollScroll(event) {
      console.log(event)
      let _that = this;
      let scrollVal = event.wheelDelta || event.detail;
      if (_that.scrollBox.time) {
        clearTimeout(_that.scrollBox.time)
      }
      _that.scrollBox.time = setTimeout(() => {
        scrollVal > 0 ? _that.$refs.carousel.prev() : _that.$refs.carousel.next();
      }, 300);
    },
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
}

</script>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.swiper-box .el-carousel__indicator--vertical .el-carousel__button {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #C6E0FF;
  border: none;
  box-sizing: content-box;
  border: 2px solid rgba(0, 0, 0, 0);

}

.swiper-box .el-carousel__indicator.is-active button {
  background-color: #0D76FF;
  border: 2px solid #C6E0FF;
}

.yin1 {
  width: 280px;
  height: 500px;
  float: left;
  background: url(../assets/images/cardiobrain/yin1.png) 0 0 no-repeat;
  padding: 40px 30px;
  box-sizing: border-box;
}

.yin2 {
  width: 290px;
  height: 240px;
  float: left;
  background: url(../assets/images/cardiobrain/yin2.png) 0 0 no-repeat;
  margin-left: 20px;
  padding: 40px 30px;
  box-sizing: border-box;
}

.yin3 {
  width: 290px;
  height: 240px;
  float: left;
  background: url(../assets/images/cardiobrain/yin3.png) 0 0 no-repeat;
  margin-left: 20px;
  padding: 40px 30px;
  box-sizing: border-box;
}

.yin4 {
  width: 600px;
  height: 240px;
  float: left;
  background: url(../assets/images/cardiobrain/yin4.png) 0 0 no-repeat;
  margin-left: 20px;
  margin-top: 20px;
  padding: 40px 30px;
  box-sizing: border-box;
}

.yin5 {
  width: 280px;
  height: 500px;
  float: right;
  background: url(../assets/images/cardiobrain/yin5.png) 0 0 no-repeat;
  margin-left: 20px;
  padding: 40px 30px;
  box-sizing: border-box;
}

.aquchu {
  text-decoration: none;
  color: #fff;
}

.aquchu:hover,
.aquchu:visited,
.aquchu:link,
.aquchu:active {
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/cardiobrain.vue